import { localize } from 'mixins/helpers'

export const ADS = [
  {
    value: "INITIATION_BANKRUPTCY_ANNOUNCEMENT",
    label: 'find-ads-full-announcement-bankruptcy',
  },
  {
    value: "INITIATION_REHABILITATION_ANNOUNCEMENT",
    label: 'find-ads-full-announcement-proceedings',
  },

  {
    value: "DECLARING_BANKRUPT_ANNOUNCEMENT",
    label: 'find-ads-full-announcement-recognition',
  },
  {
    value: "BANKRUPTCY_MEETING_NOTICE",
    label: 'find-ads-full-notification-bankruptcy',
  },
  {
    value: "REHABILITATION_MEETING_NOTICE",
    label: 'find-ads-full-notification-rehabilitation',
  },
];

export const INITIATION_BANKRUPTCY_ANNOUNCEMENT = (translations:any) => {
  return [
    {
      title: localize('region', translations),
      dataIndex: "regionRu",
      key: "regionRu",
    },
    {
      title: localize('find-ads-full-name', translations),
      dataIndex: "debtor",
      render: (debtor) => debtor.ru || debtor.kk || debtor.qq
    },
    {
      title: localize('find-ads-full-debtor-iin', translations),
      dataIndex: ["debtor", "taxpayerCode"],
    },
    {
      title: localize('find-ads-full-debtor-location', translations),
      dataIndex: ["debtor", "addressRu"],
    },
    {
      title: localize('find-ads-full-bankruptcy-proceedings', translations),
      dataIndex: ["court", "nameRu"],
    },
    {
      title: localize('find-ads-full-date-ruling', translations),
      dataIndex: "court",
      render: (court) => court.courtDate && court.courtDate.substring(0, 10).split('-').reverse().join('.'),
    },
    {
      title: localize('find-ads-full-surname-temporary-manager', translations),
      dataIndex: "admin",
      render: (admin) =>
        (admin.lastName ?? '') + " " + (admin.firstName ?? '') + " " + (admin.middleName ?? ''),
    },
    {
      title: localize('find-ads-full-deadline-temporary-manager', translations),
      children: [
        {
          title: localize('find-ads-from', translations),
          dataIndex: "beginDate",
          width: "5%",
          render: (beginDate) => beginDate && beginDate.substring(0, 10).split('-').reverse().join('.'),
        },
        {
          title: localize('find-ads-to', translations),
          dataIndex: "endDate",
          width: "5%",
          render: (endDate) => endDate && endDate.substring(0, 10).split('-').reverse().join('.'),
        },
      ],
    },
    {
      title: localize('find-ads-full-address-requirements', translations),
      dataIndex: "rtkAddressRu",
    },
    {
      title: localize('find-ads-full-contact-details', translations),
      dataIndex: "admin",
      render: (admin) => admin.phone + " " + admin.email,
    },
    {
      title: localize('find-ads-full-placement-date', translations),
      dataIndex: "createdDate",
      render: createdDate => createdDate && createdDate.substring(0, 10).split('-').reverse().join('.')
    },
  ];
};

export const DECLARING_BANKRUPT_ANNOUNCEMENT = (translations:any) => {
  return [
    {
      title: localize('region', translations),
      dataIndex: 'regionRu',
      key: "regionRu",
    },
    {
      title: localize('find-ads-full-name', translations),
      dataIndex: "debtor",
      render: (debtor) => debtor.ru ? debtor.ru : debtor.lastName + " " + debtor.firstName + " " + debtor.middleName,
    },
    {
      title: localize('find-ads-full-debtor-iin', translations),
      dataIndex: ["debtor", "taxpayerCode"],
    },
    {
      title: localize('find-ads-full-debtor-location', translations),
      dataIndex: ["debtor", "addressRu"],
    },
    {
      title: localize('find-ads-full-information-state-registration', translations),
      dataIndex: "regInfo",
    },
    {
      title: localize('find-ads-full-name-decision-declaring', translations),
      dataIndex: ["court", "nameRu"],
    },
    {
      title: localize('find-ads-full-date-decision', translations),
      dataIndex: "court",
      render: (court) => court.courtDate && court.courtDate.substring(0, 10).split('-').reverse().join('.'),
    },
    {
      title: localize('find-ads-full-placement-date', translations),
      dataIndex: "createdDate",
      render: createdDate => createdDate && createdDate.substring(0, 10).split('-').reverse().join('.')
    },
  ];
};

export const BANKRUPTCY_MEETING_NOTICE = (translations:any) => {
  return [
    {
      title: localize('region', translations),
      dataIndex: 'regionRu',
      key: "regionRu",
    },
    {
      title: localize('find-ads-full-name', translations),
      dataIndex: "debtor",
      render: (debtor) => debtor.ru ? debtor.ru : debtor.lastName + " " + debtor.firstName + " " + debtor.middleName,
    },
    {
      title: localize('find-ads-full-debtor-iin', translations),
      dataIndex: ["debtor", "taxpayerCode"],
    },
    {
      title: localize('find-ads-full-debtor-location', translations),
      dataIndex: ["debtor", "addressRu"],
    },
    {
      title: localize('find-ads-full-date-meeting', translations),
      dataIndex: "meetingDate",
      render: (meetingDate) => meetingDate && meetingDate.substring(0, 10).split('-').reverse().join('.'),
    },
    {
      title: localize('find-ads-full-time-meeting', translations),
      dataIndex: "meetingDate",
      render: (meetingDate) => meetingDate && meetingDate.substring(11, 16),
    },
    {
      title: localize('find-ads-full-venue-meeting', translations),
      dataIndex: "meetingPlaceRu",
    },
    {
      title: localize('find-ads-full-agenda-meeting', translations),
      dataIndex: "meetingAgenda",
    },
    {
      title: localize('find-ads-full-procedure', translations),
      dataIndex: "meetingFamiliarization",
    },
    {
      title: localize('find-ads-full-contact-details', translations),
      dataIndex: "admin",
      render: (admin) => admin.phone + " " + admin.email,
    },
    {
      title: localize('find-ads-full-placement-date', translations),
      dataIndex: "createdDate",
      render: createdDate => createdDate && createdDate.substring(0, 10).split('-').reverse().join('.')
    },
  ];
}
